



























  import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
  import ReportingDetail from "@/views/Support/ReportingDetail.vue";

@Component({
  components: {
    ReportingDetail
  },
})
export default class ReportingTableCard extends Vue {

  @Prop() items!:any
  @Prop() totalItems!:any
  @Prop() loading!:any

  public itemPerPageOptions:any ={'items-per-page-options': [2, 5, 10, 20]}
  public options = {
    page: 1,
    itemsPerPage: 5
  }
  public expanded:any = []
  public singleExpand:boolean =  true
  public dialog = false
  public reportingId:any = null

  public headers:any=[
    {text: 'RP Id', value: 'id'},
   // {text: 'Description', value: 'description',},
    {text: 'Driver Id', value: 'driver.id'},
    {text: 'Client Name', value: 'driver.client_name',},
    {text: 'Driver Status', value: 'driver.status',},

    { text: '', value: 'data-table-expand' },
  ]

    @Watch('options', {deep: true})
    public emitOption(options:any){
      this.$emit('selectedReportingOptions', options )
    }

  public showReportingDetail(item:any) {
    this.dialog = false;
    this.reportingId = item.id
    //this.$router.push({name: 'reservation', params: {id: item.id}})
//   this.url = this.$router.resolve({name: 'reservation', params: {id: item.id}})
// console.log(JSON.stringify(this.url.href))
    this.$nextTick(() => {
      this.dialog = true;
    })
  }

}
